import { Stack } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import React from 'react';

import { AccessTabStyledContainer } from './StyledComponents';

function AccessTabSkeleton() {
  return (
    <AccessTabStyledContainer>
      <div className="main-tab-column">
        <Skeleton variant="rounded" width={'100%'} height={240} />
      </div>
    </AccessTabStyledContainer>
  );
}

export { AccessTabSkeleton };
